import { render, staticRenderFns } from "./bannerTable.vue?vue&type=template&id=6e5f84ec"
import script from "./bannerTable.vue?vue&type=script&lang=js"
export * from "./bannerTable.vue?vue&type=script&lang=js"
import style0 from "./bannerTable.vue?vue&type=style&index=0&id=6e5f84ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports